import React, { useState, useEffect } from "react";
import ApplicantForm from "./ApplicantForm";
import Container from "react-bootstrap/Container";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import ThankYouSuccessModal from "../Modals/ThankYouSuccessModal";
import { useNavigate } from "react-router-dom";
import { submitApplication } from "../../services/api";
import { useToast } from "../../contexts/ToastContext";
import { useLoading } from "../../contexts/LoadingContext";

const ApplicationForm = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { startLoading, stopLoading } = useLoading();
  const [thankYouModalShow, setThankyouModalShow] = useState(false);
  const [errors, setErrors] = useState({
    applicant: {}
  });
  const navigate = useNavigate();
  const { showToast } = useToast();
  const role = localStorage.getItem('selectedRole');

  // Redirect to home if role is not selected (direct URL access)
  useEffect(() => {
    if (!role) {
      navigate("/");
    }
  }, [role, navigate]);

  const initialFormValue = {
    applicant: {
      role: "",
      name: "",
      address: "",
      phoneNumber: "",
      email: "",
      communityEmailAddress: "",
      planReviewType: "",
      comments: "",
      files: "",
      fileLink: ""
    }
  };
  const [formData, setFormData] = useState(initialFormValue);
  const handleDataChange = (section, field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [section]: { ...prevData[section], [field]: value },
    }));
  };


  const handleValidate = (section, field, error) => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [section]: { ...prevErrors[section], [field]: error },
    }));
  };

  const isStepValid = () => {  
    const fields = [
      { name: "name", value: formData.applicant.name, label: "Name" },
      { name: "address", value: formData.applicant.address, label: "Address" },
      { name: "phoneNumber", value: formData.applicant.phoneNumber, label: "Phone Number" },
      { name: "email", value: formData.applicant.email, label: "Email" },
      { name: "communityEmailAddress", value: formData.applicant.communityEmailAddress, label: "Community Email Address" },
      { name: "planReviewType", value: formData.applicant.planReviewType, label: "Plan Review Type" },
      { name: "comments", value: formData.applicant.comments, label: "Comments" }
    ];
  
    const firstEmptyField = fields.find(field => !field.value);
  
    if (firstEmptyField) {
      return { isValid: false, firstErrorField: firstEmptyField };
    }
  
    const errorField = Object.keys(errors.applicant).find(key => errors.applicant[key] !== "");
  
    if (errorField) {
      return { isValid: false, firstErrorField: { name: errorField, label: errorField } };
    }
  
    return { isValid: true, firstErrorField: null };
  };  

  const handleSubmit = () => {
    const { isValid, firstErrorField } = isStepValid();
  
    if (!isValid) {
      showToast(`Please fill in the ${firstErrorField.label} field before submitting.`, "error");
  
      // Focus on the first invalid field if it exists
      const inputElement = document.getElementById(`applicant${firstErrorField.name}`);
      if (inputElement) {
        inputElement.focus();
      }
  
      return;
    }
  
    submitForm();
  };  

  const submitForm = async () => {
    setIsSubmitting(true);
    startLoading();
    try {
      formData.applicant.role = role;
      await submitApplication(formData.applicant);
      setThankyouModalShow(true);
    } catch (error) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          showToast(error.response.data.message, "error");
        } else {
          showToast("There was an error submitting your application.", "error");
        }
    } finally {
      setIsSubmitting(false);
      stopLoading();
    }
  };

  const resetForm = () => {
    setFormData(initialFormValue);
    navigate("/");
  };

  const handleRedirectModel = () => {
      setThankyouModalShow(false);
      resetForm();
  }

  return (
    <>
      <Container className="stepper-container px-5" fluid>
        <Breadcrumb className="py-4">
          <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
          <Breadcrumb.Item active>Plan Review Request</Breadcrumb.Item>
        </Breadcrumb>
        <ApplicantForm
            data={formData.applicant}
            onChange={(field, value) =>
              handleDataChange("applicant", field, value)
            }
            onValidate={(field, error) =>
              handleValidate("applicant", field, error)
            }
            errors={errors.applicant || {}}
        />

        <div className="stepper-navigation d-flex mb-4 justify-content-end mt-4 ">
        <button
              type="submit"
              id="submitForm"
              onClick={handleSubmit}
              className="btn btn-submit"
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </button>
        </div>
      </Container>
      <ThankYouSuccessModal
        show={thankYouModalShow}
        onHide={handleRedirectModel}
        onRedirect={resetForm}
      />
    </>
  );
};

export default ApplicationForm;